import { render, staticRenderFns } from "./FarmerPage.vue?vue&type=template&id=52741882"
import script from "./FarmerPage.vue?vue&type=script&lang=js"
export * from "./FarmerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports